import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  id: null,
};

export const storySlice = createSlice({
  name: "story",
  initialState,
  reducers: {
    setStory: (state, action) => {
      state.id = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setStory } = storySlice.actions;

export default storySlice.reducer;
